import { helpers } from 'vuelidate/lib/validators';

export default function(value, numBytes) {
  const fileSize = value?.size || 0;
  return !helpers.req(value) || fileSize < numBytes;
}
